'use client'

import { Divider } from '@macarongfactory/web-ui'

import CarStoryTabError from './CarStoryTabError'
import CarStoryTabLoading from './CarStoryTabLoading'
import CuratedSwiperSection from './CuratedSwiperSection'
import TopicContentsSection from './TopicContentsSection'
import {
  carStoryTracking,
  toCuratedItem,
  toTopicContentItem,
  toTopicFilters,
} from '../lib'
import {
  MYCLE_CONTENT_MENU,
  MYCLE_CONTENT_SERIES_CODE,
  useCarStoryTabPage,
} from '../model'

const CarStoryMaintenancePage = () => {
  const {
    selectedSort,
    setSelectedSort,
    selectedCategoryId,
    setSelectedCategoryId,
    seriesData,
    categoriesData,
    contentsItems,
    isLoading,
    isError,
    retry,
    isContentsLoading,
    isContentsError,
    refetchContents,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
  } = useCarStoryTabPage({
    menu: MYCLE_CONTENT_MENU.CAR,
    seriesCode: MYCLE_CONTENT_SERIES_CODE.CARE,
    onPageView: carStoryTracking.showCarcarePage,
  })

  if (isLoading) return <CarStoryTabLoading />
  if (isError) return <CarStoryTabError onRetry={retry} />

  const curatedItems = (seriesData?.content ?? []).map(toCuratedItem)
  const topicItems = contentsItems.map(toTopicContentItem)
  const topicFilters = toTopicFilters(categoriesData ?? [])

  return (
    <div>
      <CuratedSwiperSection
        title='관리의 정석'
        description='기본부터 확실한 차량 관리'
        items={curatedItems}
        onCardShow={(item, index) =>
          carStoryTracking.showCarcareTopContentCard(item.title, index)
        }
        onCardClick={(item, index) =>
          carStoryTracking.clickCarcareTopContentCard(item.title, index)
        }
        onFirstSwipe={carStoryTracking.scrollCarcareTopContents}
      />
      <Divider.Horizontal strokeWidth='stroke-width-x10' />
      <TopicContentsSection
        filters={topicFilters}
        items={topicItems}
        isContentsLoading={isContentsLoading}
        isContentsError={isContentsError}
        onContentsRetry={refetchContents}
        selectedSort={selectedSort}
        selectedCategoryId={selectedCategoryId}
        onCategoryChange={setSelectedCategoryId}
        onSortChange={setSelectedSort}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isFetchNextPageError={isFetchNextPageError}
        onFetchNextPage={fetchNextPage}
        tracking={{
          onSortClick: carStoryTracking.clickCarcareSortFilter,
          onChipShow: carStoryTracking.showCarcareTopicChip,
          onChipClick: carStoryTracking.clickCarcareTopicChip,
          onChipScroll: carStoryTracking.scrollCarcareTopicChips,
          onCardShow: (item, selectedFilter) =>
            carStoryTracking.showCarcareTopicCard(item.title, selectedFilter),
          onCardClick: (item, selectedFilter) =>
            carStoryTracking.clickCarcareTopicCard(item.title, selectedFilter),
        }}
      />
    </div>
  )
}

export default CarStoryMaintenancePage
